<template>
  <div class="selectProductDetail">
    <div v-show="isShowTit">为每个要推广的产品创建一个广告组，你可以<span class="btn" @click="dialogVisible = true">从网站中选择</span>要推广的分类页或产品详情页，系统将为你自动生成一些推荐的关键词、广告语</div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      @open="open"
      width="40%">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="推广产品分类" name="classify">
          <!-- <skyCheckboxCard :groups="groups" :domain="domain" v-model="classify"></skyCheckboxCard> -->
          <skyCheckBoxCardPrd :groups="groups" :domain="domain" v-model="classify"></skyCheckBoxCardPrd>
        </el-tab-pane>
        <el-tab-pane label="推广产品" name="product">
          <skyCheckboxCard :domain="domain" :isProductList="true" :props="productListProps" v-model="classify"></skyCheckboxCard>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="isShowTit" type="primary" @click="confirm">确 定</el-button>
        <el-button v-show="!isShowTit" type="primary" @click="aiConfirm">AI撰写</el-button>
      </span>
      <div>已选：{{ selectedLength }} / 1</div>
    </el-dialog>
  </div>
</template>
<script>
import skyCheckboxCard from './skyCheckboxCard.vue';
import skyCheckBoxCardPrd from './skyCheckBoxCardPrd.vue';
export default {
  props: {
    value: {
			type: Array,
			default: () => {
				return [];
			},
			required: true
		},
    domain: {
      type: String,
      default: ''
    },
    isShowTit: {
      // 是否显示点击标题
      type: Boolean,
      default: true
    },
    ruleType: {
      // ai撰写类型
      type: Number
    }
  },
  components: { skyCheckboxCard, skyCheckBoxCardPrd },
  data() {
      return {
        dialogVisible: false,
        activeName: 'classify',
        groups: {
          others: [
            {
							tagName: 'sky-select',
							placeholder: '分类',
							prop: 'online',
							value: '0',
							options: [
                {
                  value: '0',
                  label: '全部分类',
                },
                // {
                //   value: '1',
                //   label: '一级分类',
                // },
                // {
                //   value: '2',
                //   label: '二级分类',
                // },
                // {
                //   value: '3',
                //   label: '三级分类',
                // },
              ]
						},
          ]
        },
        classify: [],
        productListProps: {
					id: 'id',
					url: 'path',
          imgUrl: 'url',
					fileName: 'name',
          weight: 'weight'
				},
      };
  },
  watch: {
		value: {
			handler(val) {
				this.classify = val;
			},
			immediate: true,
			deep: true
		}
	},
  computed: {
    selectedLength() {
      return [...this.classify].length
    }
	},
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    confirm() {
      this.dialogVisible = false;
      this.$emit('change', this.classify);
			this.$emit('input', this.classify);
    },
    aiConfirm() {
      // ai撰写 url产品通过检验后，打开ai撰写弹框
      this.dialogVisible = false;
      this.$emit('change', this.classify);
			this.$emit('input', this.classify);
      this.$emit('openTitleDrawer', this.ruleType);
    },
    open() {
      this.classify = this.value;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.selectProductDetail {
  .btn {
    color: #409eff;
    cursor: pointer;
  }
}
</style>